import React from "react"
import { Collapsible } from "../collapsible"

// =============================================================================
// Props
// =============================================================================

export type StepperItemContentProps = {
  /** Content revealed when the step is expanded */
  children?: React.ReactNode
}

// =============================================================================
// Component
// =============================================================================

/**
 * The collapsible panel revealed when an expandable step is open.
 *
 * Must be a descendant of an expandable `Stepper.Item`.
 */
export function StepperItemContent({ children }: StepperItemContentProps) {
  return (
    <Collapsible.Content>
      <div className="pt-2 text-sm text-gray-800">{children}</div>
    </Collapsible.Content>
  )
}

StepperItemContent.displayName = "Stepper.ItemContent"
